import { MapPin, Phone } from "lucide-react";
import QRCard from "../QRCard";

const cities = [
  { name: "Rockledge", note: "HQ & crew base" },
  { name: "Melbourne", note: "Tree service & landscaping" },
  { name: "Cocoa", note: "Palm trimming & removals" },
  { name: "Cocoa Beach", note: "Storm cleanup specialists" },
  { name: "Merritt Island", note: "Full yard & landscape" },
  { name: "Cape Canaveral", note: "Coastal tree work" },
  { name: "Titusville", note: "Stump grinding & hauling" },
  { name: "Viera", note: "Residential & commercial" },
];

export default function ServiceArea() {
  return (
    <section
      id="service-area"
      data-testid="service-area-section"
      className="relative py-24 md:py-32 bg-[#0B1810] text-white overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-15 mix-blend-overlay"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/13956349/pexels-photo-13956349.jpeg?auto=compress&cs=tinysrgb&w=1600')",
          backgroundSize: "cover",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="overline text-[#FF5A00] mb-4">Service Area</div>
            <h2 className="h-section">
              Serving All of
              <br />
              <span className="text-[#FF5A00]">Brevard County, FL.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-lg text-white/80 font-body">
            Hurricane Cuts is a local, licensed and insured tree service &amp;
            landscaping company based in Rockledge, Florida. From Titusville in
            the north to Melbourne and Viera in the south — and every beach
            town in between — we show up, cut clean, and haul it all away.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {cities.map((c) => (
            <div
              key={c.name}
              data-testid={`city-card-${c.name.toLowerCase().replace(" ", "-")}`}
              className="border-2 border-[#2A332C] bg-[#070C08] p-5 hover:border-[#FF5A00] hover:-translate-y-1 transition-all group"
            >
              <MapPin
                size={18}
                className="text-[#FF5A00] mb-3"
                strokeWidth={2.5}
              />
              <div className="font-heading text-2xl md:text-3xl tracking-wide group-hover:text-[#FF5A00] transition-colors">
                {c.name}
              </div>
              <div className="font-accent text-[10px] tracking-[0.2em] uppercase text-white/50 mt-2">
                {c.note}
              </div>
              <div className="font-accent text-[10px] tracking-[0.2em] uppercase text-white/40 mt-1">
                Florida · 32955+
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap gap-2 items-center text-white/60 font-body text-sm">
          <span className="font-accent tracking-[0.2em] uppercase text-[#FF5A00] text-xs mr-2">
            Also serving:
          </span>
          {[
            "Palm Bay",
            "Satellite Beach",
            "Indian Harbour Beach",
            "West Melbourne",
            "Port St. John",
            "Mims",
            "Suntree",
            "Grant-Valkaria",
          ].map((n, i, arr) => (
            <span key={n}>
              {n}
              {i < arr.length - 1 && <span className="text-[#FF5A00] mx-2">·</span>}
            </span>
          ))}
        </div>

        <div className="mt-14 p-8 md:p-10 border-l-4 border-[#FF5A00] bg-[#070C08] flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="flex-1">
            <div className="font-heading text-3xl md:text-4xl">
              Need a tree service in{" "}
              <span className="text-[#FF5A00]">Rockledge, Melbourne, Cocoa</span>{" "}
              or anywhere in Brevard?
            </div>
            <p className="text-white/70 font-body mt-2">
              Call or text Ben for a free on-site estimate — usually same-day.
            </p>
            <a
              data-testid="service-area-cta"
              href="tel:+13216826085"
              className="btn-primary flex-shrink-0 mt-5"
            >
              <Phone size={18} /> (321) 682-6085
            </a>
          </div>
          <div className="flex-shrink-0">
            <QRCard
              variant="light"
              size={140}
              label="Scan to Save & Share"
              sub="hurricanecuts.com"
              testId="qr-service-area"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
